module.exports = __webpack_public_path__ + "static/media/loanagainstfixeddeposit.65e9efc8.svg";